export const ADD_REPORT_DATA = 'ADD_REPORT_DATA'
export const RESET_REPORT_DATA = 'RESET_REPORT_DATA'
export const ADD_REPORT_TYPE_MAPPING = 'ADD_REPORT_TYPE_MAPPING'
